import { ColorHex } from '@carboncopyco/ui';
import type Highcharts from 'highcharts';
import type { SeriesOptionsType } from 'highcharts';
import { baseTooltipOptions } from '../consts';

type LineChartConfigOptions = {
  data: number[];
  name: string;
  xCategories: string[];
  extraOptions?: Highcharts.Options;
  color?: SeriesOptionsType['color'];
};

export const getChartOptions = ({
  data,
  extraOptions = {},
  color = ColorHex.primary200,
  name,
  xCategories,
}: LineChartConfigOptions): Highcharts.Options => {
  const isZeroData = data.every((value) => value === 0);
  const yAxisMin = isZeroData ? -1 : -0.001;
  const yAxisMax = isZeroData ? 1 : null;

  return {
    accessibility: {
      enabled: false,
    },
    chart: {
      type: 'spline',
      height: 80,
      spacingRight: 10,
      spacingLeft: 10,
      spacingTop: 20,
      spacingBottom: -30,
    },
    credits: {
      enabled: false,
    },
    title: {
      text: '',
    },
    legend: {
      enabled: false,
    },
    xAxis: {
      visible: false,
      categories: xCategories,
      labels: {
        enabled: false,
      },
    },
    yAxis: {
      title: {
        text: '',
      },
      labels: {
        enabled: false,
      },
      gridLineColor: '',
      endOnTick: false,
      min: yAxisMin,
      max: yAxisMax,
      maxPadding: 0.5,
    },
    tooltip: baseTooltipOptions,
    plotOptions: {
      spline: {
        linecap: 'round',
        marker: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name,
        color,
        marker: { enabled: false },
        data,
        type: 'spline',
      },
    ],
    ...extraOptions,
  };
};
